import { useCallback, useState } from 'react';
import API from '../../../Infrastructure/API';

interface Settings {
  authToken?: string;
}

export default function useMultifactorAuthenticationGenerate({ authToken }: Settings) {
  const [response, setResponse] = useState<Awaited<ReturnType<typeof API.multiFactorAuthentication.generate>>>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [fetched, setFetched] = useState(false);

  const generate = useCallback(() => {
    if (!authToken) {
      return;
    }

    setLoading(true);
    setError(false);

    API.multiFactorAuthentication
      .generate(authToken)
      .then((response) => {
        setResponse(response);
        setFetched(true);
      })
      .catch(() => {
        setError(true);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [authToken]);

  return {
    response,
    generate,
    loading,
    error,
    fetched,
  };
}
